import BaseAPI, { recoverFromNotFound, ROUTES, VERSIONS } from './BaseAPI'

const { VERSION_TWO } = VERSIONS
const { DISTRIBUTION_LIST_FIND } = ROUTES

export default class DistributionListsAPI extends BaseAPI {
  @recoverFromNotFound()
  async find(id: string) {
    const { version=VERSION_TWO } = super.getVersion(DISTRIBUTION_LIST_FIND)

    const res = await this.httpClient.get('/:version/dist_list/:id', {
      urlParams: {
        id,
        version,
      },
    })

    return res.data
  }
}
